import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-145b2072"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "live-feed" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "loader" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "Laden")
], -1))
const _hoisted_3 = {
  id: "live-feed__video",
  ref: "videoFeed",
  autoplay: "",
  muted: ""
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("video", _hoisted_3, null, 512)
  ]))
}